/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateRiskPolicyBypassRequestRequestBody = {
  /**
   * The requester's own justification for needing this, shown to whoever decides. Optional: an older client that sends none falls back to the policy's block reason.
   */
  note?: string | undefined;
  /**
   * Signed request token generated when a risk policy blocks an action.
   */
  requestToken: string;
};

/** @internal */
export type CreateRiskPolicyBypassRequestRequestBody$Outbound = {
  note?: string | undefined;
  request_token: string;
};

/** @internal */
export const CreateRiskPolicyBypassRequestRequestBody$outboundSchema:
  z.ZodMiniType<
    CreateRiskPolicyBypassRequestRequestBody$Outbound,
    CreateRiskPolicyBypassRequestRequestBody
  > = z.pipe(
    z.object({
      note: z.optional(z.string()),
      requestToken: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        requestToken: "request_token",
      });
    }),
  );

export function createRiskPolicyBypassRequestRequestBodyToJSON(
  createRiskPolicyBypassRequestRequestBody:
    CreateRiskPolicyBypassRequestRequestBody,
): string {
  return JSON.stringify(
    CreateRiskPolicyBypassRequestRequestBody$outboundSchema.parse(
      createRiskPolicyBypassRequestRequestBody,
    ),
  );
}
